<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisModal from 'dashboard/components-next/LaisModal.vue';

defineProps({
  show: { type: Boolean, default: false },
  listName: { type: String, default: '' },
  totalFavorites: { type: Number, default: 0 },
});

const emit = defineEmits(['close', 'edit', 'organize', 'delete']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    title="Configurar lista"
    max-width-class="max-w-[520px]"
    @close="emit('close')"
  >
    <div class="space-y-3">
      <div class="rounded-lais border border-lais-border bg-[#faf8fd] p-4">
        <p class="text-[15px] font-semibold text-lais-text">
          {{ listName || 'Lista atual' }}
        </p>
        <p class="mt-1 text-[12px] text-lais-text-muted">
          Imóveis salvos nesta coleção: {{ totalFavorites }}.
        </p>
      </div>

      <button
        type="button"
        class="flex w-full items-start gap-3 rounded-lais border border-lais-border bg-white px-4 py-4 text-left transition-all hover:border-lais-primary"
        @click="emit('edit')"
      >
        <span class="i-lucide-pencil-line mt-0.5 size-4 text-lais-primary" />
        <span>
          <span class="block text-[14px] font-semibold text-lais-text">
            Editar lista
          </span>
          <span class="mt-1 block text-[12px] leading-5 text-lais-text-muted">
            Ajuste o nome sem perder os favoritos já salvos.
          </span>
        </span>
      </button>

      <button
        type="button"
        class="flex w-full items-start gap-3 rounded-lais border border-lais-border bg-white px-4 py-4 text-left transition-all hover:border-lais-primary"
        @click="emit('organize')"
      >
        <span class="i-lucide-list-filter mt-0.5 size-4 text-lais-primary" />
        <span>
          <span class="block text-[14px] font-semibold text-lais-text">
            Organizar favoritos
          </span>
          <span class="mt-1 block text-[12px] leading-5 text-lais-text-muted">
            Mova imóveis selecionados para outra lista sem perder o contexto do
            cliente.
          </span>
        </span>
      </button>

      <button
        type="button"
        class="flex w-full items-start gap-3 rounded-lais border border-[#f1c9cf] bg-white px-4 py-4 text-left transition-all hover:bg-[#fff5f6]"
        @click="emit('delete')"
      >
        <span class="i-lucide-trash-2 mt-0.5 size-4 text-[#b42318]" />
        <span>
          <span class="block text-[14px] font-semibold text-[#b42318]">
            Excluir lista
          </span>
          <span class="mt-1 block text-[12px] leading-5 text-lais-text-muted">
            Remove a lista e os favoritos vinculados a ela.
          </span>
        </span>
      </button>
    </div>
  </LaisModal>
</template>
